'use client'

import React, { useState } from 'react'
import { Link } from '@/lib'
import { Button } from '@/components/ui/button'
import { List, X, House, User, FlowArrow, Envelope, SignOut, Palette } from 'phosphor-react'
import { useAuth } from '../contexts/AuthContext'
import { useMobileViewport } from '../hooks/use-mobile-viewport'

export default function MobileNavigation() {
  const [isOpen, setIsOpen] = useState(false)
  const { logout, isAuthenticated } = useAuth()
  useMobileViewport()

  const toggleMenu = () => {
    setIsOpen(!isOpen)
  }

  const closeMenu = () => {
    setIsOpen(false)
  }

  const handleLogout = () => {
    logout()
    closeMenu()
  }

  const menuItems = [
    { to: '/Home', label: 'Home', icon: House, protected: false },
    { to: '/CreativeProjects', label: 'Creative', icon: Palette, protected: false },
    { to: '/ProfessionalProjects', label: 'Product & Design', icon: FlowArrow, protected: false },
    { to: '/Process', label: 'Process', icon: FlowArrow, protected: true },
    { to: '/About', label: 'About', icon: User, protected: true },
    { to: '/Contact', label: 'Contact', icon: Envelope, protected: false }
  ].filter(item => !item.protected || isAuthenticated)

  const itemClass =
    'brutal-panel rounded-none px-4 py-2 text-[var(--brutal-ink)] hover:bg-[var(--brutal-kraft)] shadow-[var(--brutal-shadow-sm)] transition-optimized flex items-center space-x-2 min-w-[140px]'

  return (
    <>
      {isOpen && (
        <div
          className="fixed inset-0 bg-[var(--brutal-ink)]/40 z-40 md:hidden"
          onClick={closeMenu}
        />
      )}

      {isOpen && (
        <div className="mobile-menu-items md:hidden">
          <div className="flex flex-col space-y-2">
            {menuItems.map((item, index) => {
              const IconComponent = item.icon
              return (
                <div
                  key={item.to}
                  className="animate-in slide-in-from-bottom-2 fade-in duration-200"
                  style={{ animationDelay: `${index * 50}ms` }}
                >
                  <Button
                    asChild
                    variant="ghost"
                    size="sm"
                    className={itemClass}
                    onClick={closeMenu}
                  >
                    <Link
                      to={item.to}
                      className="flex items-center space-x-2"
                      onClick={() => window.scrollTo({ top: 0, behavior: 'auto' })}
                    >
                      <IconComponent weight="duotone" className="w-4 h-4" />
                      <span className="text-sm font-semibold">{item.label}</span>
                    </Link>
                  </Button>
                </div>
              )
            })}

            {isAuthenticated && (
              <div
                className="animate-in slide-in-from-bottom-2 fade-in duration-200"
                style={{ animationDelay: `${menuItems.length * 50}ms` }}
              >
                <Button
                  variant="ghost"
                  size="sm"
                  className={`${itemClass} text-[var(--brutal-accent)]`}
                  onClick={handleLogout}
                >
                  <SignOut weight="duotone" className="w-4 h-4" />
                  <span className="text-sm font-semibold">Logout</span>
                </Button>
              </div>
            )}
          </div>
        </div>
      )}

      <div className="mobile-floating-button md:hidden">
        <Button
          variant="ghost"
          size="sm"
          className={`brutal-btn rounded-none w-14 h-14 p-0 transition-all duration-200 ${
            isOpen ? 'rotate-180' : 'rotate-0'
          }`}
          onClick={toggleMenu}
          aria-label={isOpen ? 'Close menu' : 'Open menu'}
        >
          {isOpen ? (
            <X weight="bold" className="w-6 h-6" />
          ) : (
            <List weight="bold" className="w-6 h-6" />
          )}
        </Button>
      </div>
    </>
  )
}
